import React, { useState, useEffect, useRef, useCallback } from "react";
import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

// Components
import FiltersSection from "./FiltersSection";
import FiltersStatus from "./FiltersStatus";
import CardsFeedSection from "./CardsFeedSection";

function WhatsOnReact() {
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);

    /**
     * Portals
     */
    const filterStatusSection = document.getElementById("react-filters-status");
    const cardsSection = document.getElementById("react-cards-feed");

    /**
     * States
     */
    const [filters, setFilters] = useState({}); //Read from JSON.
    const [datesEventsHappening, setdatesEventsHappening] = useState([]);

    const defaultFiltersVals = {
        hideMoreFilters: true,
        categories: [],
        when: [],
        selectedDates: [],
        composers: [],
        locations: [],
        when_sel_dates:[],
        cal_sel_dates:[],
    };

    const [selectedFilters, setSelectedFilters] = useState({
        ...defaultFiltersVals,
        is_filtered: false,
    });

    const [allCards, setAllCards] = useState([]);
    const [filteredCards, setFilteredCards] = useState([]);

    const [isMobile, setIsMobile] = useState(
        window.matchMedia("(max-width: 768px)").matches,
    );

    /**
     * Variables
     */
    let jsonFile = "";
    let reactDataLoaded = false;

    const icons = getIcons();

    const filterStatusBtns = {
        categories: {},
        when: {},
        selectedDates: {},
        composers: {},
        locations: {},
    };

    const featuredStaticItems = {
        events: document.getElementById("whats-on-featured-events"),
    };

    const filtersStatusSection = document.querySelector(
        "[data-filters-status]",
    );

    /**
     * - - - - - - - - - - Effects - - - - - - - - - -
     */

    /**
     * Hide all featured events and promo blocks, if any filtered is triggered.
     */
    React.useEffect(() => {
        // Bail.

        console.log( 'are filters off', areFiltersOff(selectedFilters));

        if (reactDataLoaded) {
            if (
                selectedFilters.is_filtered &&
                !areFiltersOff(selectedFilters)
            ) {
                displayStaticItems("none");
                filtersStatusSection.ariaHidden = false;
            } else if (areFiltersOff(selectedFilters)) {
                displayStaticItems();
                filtersStatusSection.ariaHidden = true;
            } else {
                displayStaticItems();
                filtersStatusSection.ariaHidden = true;
            }
        }
    }, [selectedFilters]);

    /**
     * Get data from WP-API
     *  This hooks depends on the value of the what's on tab to load pre-filtered JSONs
     */
    useEffect(() => {
        jsonFile = "/wp-content/uploads/whats-on.json";

        const fetch_data = async () => {
            await fetch(jsonFile)
                .then((response) => response.json())
                .then((data) => {
                    setAllCards(data.cards);
                    setFilters(data.filters);
                    setdatesEventsHappening(data.dates_events_happening);

                    displayStaticItems();
                });
        };

        fetch_data();

        return () => {};
    }, []);

    /**
     * Filter data
     */
    useEffect(() => {
        if (allCards.length && Object.keys(selectedFilters).length) {
            let tmpFilterCards = [];

            if (allCards.length && Object.keys(selectedFilters).length) {
                tmpFilterCards = allCards.filter((card) => {
                    let instances = card.instances;

                    // Type categories.
                    let catFilter = true;
                    if (selectedFilters.categories.length) {
                        if (card.category_terms.length) {
                            let catSlugs = card.category_terms.map(
                                (item) => item["slug"],
                            );

                            catFilter = selectedFilters.categories.some((tag) =>
                                catSlugs.includes(tag),
                            );
                        } else {
                            catFilter = false;
                        }
                    }

                    // Composers filters
                    let composersFilter = true;
                    if (selectedFilters.composers.length) {
                        if (card.composer_terms.length) {
                            let composersSlugs = card.composer_terms.map(
                                (item) => item["slug"],
                            );

                            composersFilter = selectedFilters.composers.some(
                                (tag) => composersSlugs.includes(tag),
                            );
                        } else {
                            composersFilter = false;
                        }
                    }

                    // Locations filter.
                    let locationsFilter = true;
                    if (selectedFilters.locations.length) {
                        if (card.location.length) {
                            let locationSlugs = card.location.map(
                                (item) => item["slug"],
                            );

                            locationsFilter = selectedFilters.locations.some(
                                (tag) => locationSlugs.includes(tag),
                            );
                        } else {
                            locationsFilter = false;
                        }
                    }

                    // Date filters
                    let dateRangeFilter = true;
                    if (selectedFilters.when_sel_dates?.length > 1) {
                        dateRangeFilter = anyInstanceInDateRange(instances, selectedFilters.when_sel_dates);
                    }

                    // Selected date on calendar
                    let seldateFilter = true;
                    if (selectedFilters.cal_sel_dates && selectedFilters.cal_sel_dates.length === 1) {
                        seldateFilter = anyInstanceMatchingDate(instances, selectedFilters.cal_sel_dates[0]);
                    }

                    // All filters.
                    return catFilter && locationsFilter && composersFilter && dateRangeFilter && seldateFilter;
                });

                if (
                    !selectedFilters.is_filtered &&
                    tmpFilterCards.length === 0
                ) {
                    // Show all.  First load.
                    tmpFilterCards = allCards;
                } else if (areFiltersOff(selectedFilters)) {
                    // Show all , no filters selected at the moment.
                    tmpFilterCards = allCards;
                } else {
                    console.log("Cards found for filters");
                }

                // Set cards to display.
                //console.log('Cards to display:', tmpFilterCards);
                setFilteredCards(tmpFilterCards);
            } else {
                console.log("filters and cards are loading.");
            }
        }
    }, [selectedFilters, allCards]);

    // - - - - - - - - - -  Helper Functions  - - - - - - - - - -

    function displayStaticItems(state = "") {
        Object.values(featuredStaticItems).forEach((feat_item) => {
            feat_item.style.display = state;
        });
    }

    function areFiltersOff(currentFilters) {
        let tmpCurrentFilters = { ...currentFilters };
        let tmpdefaultFiltersVals = { ...defaultFiltersVals };

        tmpCurrentFilters = removePropsFromObject(tmpCurrentFilters, [
            "is_filtered",
            "hideMoreFilters",
        ]);
        tmpdefaultFiltersVals = removePropsFromObject(tmpdefaultFiltersVals, [
            "is_filtered",
            "hideMoreFilters",
        ]);

        if (
            JSON.stringify(tmpCurrentFilters) ===
            JSON.stringify(tmpdefaultFiltersVals)
        ) {
            return true;
        } else {
            return false;
        }
    }

    function removePropsFromObject(obj, whichRemove = []) {
        let newObj = {};
        if (whichRemove.length) {
            for (let key of Object.keys(obj)) {
                if (!whichRemove.includes(key)) {
                    newObj[key] = obj[key];
                }
            }
            return newObj;
        }

        return obj;
    }

    function isObject(value) {
        return value instanceof Object && !(value instanceof Array);
    }

    function anyInstanceInDateRange(instances, dateRange) {

        let rangeStart = dateRange[0] ?? false;
        let rangeEnd =  dateRange[dateRange.length -1] ?? false;
        let in_range = null;

        rangeEnd =  dayjs(rangeEnd).add(23, 'hour').toDate();

        if (rangeStart && rangeEnd && instances.length) {
             in_range = instances.filter( (instance) => {
                let instanceDate = dayjs(instance.date);
                return (instanceDate.isSameOrAfter(rangeStart) && instanceDate.isSameOrBefore(rangeEnd));
            });
        }

        return ( (in_range != null) && in_range.length > 0 ? true : false );
    }

    function anyInstanceMatchingDate(instances, selDate) {
        let found = null;

        if (instances.length) {
            found = instances.filter( (instance) => {
                return (dayjs(selDate).isSame(instance.date, 'day'));
            });
        }

        return ((found != null) && found.length > 0 ? true : false );
    }

    // - - - - - - - - - -  END Helper Functions  - - - - - - - - - -

    /**
     * - - - - - - - - - - Functions calls - - - - - - - - - -
     */

    // Is react data loaded ?
    reactDataLoaded = allCards.length > 0 && Object.keys(filters).length > 0;

    return (
        <>
            {reactDataLoaded ? (
                <FiltersSection
                    filters={filters}
                    selectedFilters={selectedFilters}
                    setSelectedFilters={setSelectedFilters}
                    filteredCards={filteredCards}
                    icons={icons}
                    isMobile={isMobile}
                    datesEventsHappening={datesEventsHappening}

                />
            ) : null}

            {!areFiltersOff(selectedFilters) && reactDataLoaded
                ? ReactDOM.createPortal(
                      <FiltersStatus
                          icons={icons}
                          selectedFilters={selectedFilters}
                          setSelectedFilters={setSelectedFilters}
                          filters={filters}
                          filterStatusBtns={filterStatusBtns}
                      />,
                      filterStatusSection,
                  )
                : null}

            {reactDataLoaded
                ? ReactDOM.createPortal(
                      <CardsFeedSection
                          filteredCards={filteredCards}
                          selectedFilters={selectedFilters}
                          icons={icons}
                      />,
                      cardsSection,
                  )
                : null}
        </>
    );
}

const container = document.getElementById("react-filters");
const root = createRoot(container);
root.render(<WhatsOnReact />);

function getIcons() {
    return {
        calendar_btn: (
            <svg width="18" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.308 19.5c-.505 0-.933-.175-1.283-.525A1.745 1.745 0 0 1 .5 17.692V4.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h1.384V.385h1.539V2.5h7.577V.385h1.5V2.5h1.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v13.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H2.308Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V8.308H2v9.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096ZM2 6.808h14v-2.5a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H2.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v2.5Z" fill="#fff"/></svg>
        ),

        more_filters: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
            >
                <mask
                    id="mask0_15375_8404"
                    customstyle="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="25"
                >
                    <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_15375_8404)">
                    <path
                        d="M11.25 21.25V15.75H12.75V17.75H20.75V19.25H12.75V21.25H11.25ZM3.25 19.25V17.75H8.75V19.25H3.25ZM7.25 15.25V13.25H3.25V11.75H7.25V9.75H8.75V15.25H7.25ZM11.25 13.25V11.75H20.75V13.25H11.25ZM15.25 9.25V3.75H16.75V5.75H20.75V7.25H16.75V9.25H15.25ZM3.25 7.25V5.75H12.75V7.25H3.25Z"
                        fill="white"
                    />
                </g>
            </svg>
        ),

        close_icon: (
            <svg
                width="14"
                height="14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.4 14 0 12.6 5.6 7 0 1.4 1.4 0 7 5.6 12.6 0 14 1.4 8.4 7l5.6 5.6-1.4 1.4L7 8.4 1.4 14Z"
                    fill="#000"
                />
            </svg>
        ),

        event_location: (
            <svg
                width="14"
                height="17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.004 8.5c.414 0 .767-.147 1.059-.442.291-.295.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 0 0 6.996 5.5c-.414 0-.767.147-1.059.442A1.456 1.456 0 0 0 5.5 7.004c0 .414.147.767.442 1.059.295.291.649.437 1.062.437ZM7 16.5c-2.18-1.82-3.809-3.512-4.885-5.074C1.038 9.864.5 8.41.5 7.062c0-1.86.618-3.42 1.854-4.677C3.59 1.128 5.135.5 6.99.5c1.854 0 3.402.628 4.645 1.885C12.88 3.642 13.5 5.201 13.5 7.063c0 1.347-.535 2.798-1.604 4.354-1.07 1.555-2.702 3.25-4.896 5.083Z"
                    fill="#000"
                ></path>
            </svg>
        ),

        load_more: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
            >
                <mask
                    id="a"
                    customstyle="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="25"
                >
                    <path fill="#D9D9D9" d="M0 .5h24v24H0z" />
                </mask>
                <g mask="url(#a)">
                    <path
                        d="m15 19.5-1.425-1.4 4.6-4.6H2v-2h16.175L13.6 6.9 15 5.5l7 7-7 7Z"
                        fill="#000"
                    />
                </g>
            </svg>
        ),
    };
}

document.querySelector('.more_filters--btn')?.addEventListener('click', function() {
    const topFilters = document.getElementById('more-filters');
    const isExpanded = this.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded and aria-hidden attributes
    this.setAttribute('aria-expanded', !isExpanded);
    topFilters.setAttribute('aria-hidden', isExpanded);

    // Ensure that the transition is smooth
    if (isExpanded) {
        // Closing the accordion
        topFilters.style.transition = 'none'; // Disable transitions to immediately collapse
        topFilters.style.maxHeight = '0';
        topFilters.style.paddingBottom = '0';

        // Force reflow to apply the collapse immediately
        topFilters.offsetHeight; // Trigger reflow

        // Re-enable transitions for smooth collapse
        requestAnimationFrame(() => {
            topFilters.style.transition = 'max-height 0.5s ease, padding-bottom 0.5s ease';
        });
    } else {
        // Expanding the accordion
        topFilters.style.transition = 'none'; // Disable transitions for immediate effect

        // Set max-height to auto to measure the content height
        topFilters.style.maxHeight = 'auto';
        topFilters.style.paddingBottom = 'var(--space--m)';

        // Force reflow to calculate the height
        const scrollHeight = topFilters.scrollHeight + 'px';
        topFilters.offsetHeight; // Trigger reflow

        // Set the measured height for smooth expansion
        topFilters.style.maxHeight = '0';
        requestAnimationFrame(() => {
            topFilters.style.transition = 'max-height 0.5s ease, padding-bottom 0.5s ease';
            topFilters.style.maxHeight = scrollHeight;
        });
    }
});

